import React, {
  useRef,
  useState,
  useEffect
} from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import moment from "moment";

export const AgregarFamilias = (props) => {
  let op = require("../../../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  // Refs para todos los campos del formulario
  const txtCedula = useRef(null);
  const txtNombre = useRef(null);
  const txtFechaNacimiento = useRef(null);
  const radioFemenino = useRef(null);
  const radioMasculino = useRef(null);
  const cmbParentesco = useRef(null);
  const txtNacionalidad = useRef(null);
  const radioEstudiaSi = useRef(null);
  const radioEstudiaNo = useRef(null);
  const cmbGradoEstudio = useRef(null);
  const txtInstitucionEstudio = useRef(null);

  // Estado para el modo de operación (1: nuevo, 2: editar, 4: consultar)
  const [operacion, setOperacion] = useState(props.operacion);

  // Estado para controlar validaciones
  const [errores, setErrores] = useState({});

  // Opciones para los select
  const opcionesParentesco = [
    "Seleccione...",
    "HIJO",
    "HIJO EXCEPCIONAL",
    "CONYUGUE",
    "PADRE",
    "MADRE",
    "HERMANO",
    "ABUELO",
    "NIETO"
  ];

  const opcionesGradoEstudio = [
    "Seleccione...",
    "PREESCOLAR",
    "PRIMARIA",
    "SECUNDARIA",
    "UNIVERSITARIO",
    "POSTGRADO"
  ];

  // Función para llenar campos cuando se edita o consulta
  const llenarCampos = (datos) => {
    if (!datos) return;
    
    console.log('Datos a llenar en modal:', datos); // Para depuración

    // Cédula
    if (txtCedula.current) txtCedula.current.value = datos.cedfam || '';

    // Nombre
    if (txtNombre.current) txtNombre.current.value = datos.nomfam ? datos.nomfam.trim() : '';

    // Fecha de nacimiento
    if (txtFechaNacimiento.current && datos.fecnac) {
      const fecha = moment(datos.fecnac).format('YYYY-MM-DD');
      txtFechaNacimiento.current.value = fecha;
    }

    // Sexo (1 = Femenino, 2 = Masculino según tu objeto)
    if (datos.sexfam === 1) { // Femenino
      if (radioFemenino.current) radioFemenino.current.checked = true;
      if (radioMasculino.current) radioMasculino.current.checked = false;
    } else if (datos.sexfam === 2) { // Masculino
      if (radioMasculino.current) radioMasculino.current.checked = true;
      if (radioFemenino.current) radioFemenino.current.checked = false;
    }

    // Parentesco
    if (cmbParentesco.current && datos.parent) {
      const parentesco = datos.parent.trim();
      // Buscar si el parentesco existe en las opciones
      const opcionIndex = opcionesParentesco.findIndex(op => op === parentesco);
      if (opcionIndex >= 0) {
        cmbParentesco.current.value = parentesco;
      }
    }

    // Nacionalidad
    if (txtNacionalidad.current) txtNacionalidad.current.value = datos.nacfam ? datos.nacfam.trim() : '';

    // ¿Estudia? (estfam: true = Sí, false = No)
    if (datos.estfam === true) {
      if (radioEstudiaSi.current) radioEstudiaSi.current.checked = true;
      if (radioEstudiaNo.current) radioEstudiaNo.current.checked = false;
    } else {
      if (radioEstudiaNo.current) radioEstudiaNo.current.checked = true;
      if (radioEstudiaSi.current) radioEstudiaSi.current.checked = false;
    }

    // Grado de estudio
    if (cmbGradoEstudio.current && datos.graest) {
      const grado = datos.graest.trim();
      const opcionIndex = opcionesGradoEstudio.findIndex(op => op === grado);
      if (opcionIndex >= 0) {
        cmbGradoEstudio.current.value = grado;
      }
    }

    // Institución de estudio
    if (txtInstitucionEstudio.current) txtInstitucionEstudio.current.value = datos.insest ? datos.insest.trim() : '';
  };

  // Efecto para cargar datos cuando se edita o consulta
  useEffect(() => {
    setOperacion(props.operacion);
    
    if (props.datos && (props.operacion === 2 || props.operacion === 4)) {
      // Llamar a llenarCampos cuando se reciben datos
      setTimeout(() => {
        llenarCampos(props.datos);
      }, 100); // Pequeño retraso para asegurar que los refs estén listos
      
      if (props.operacion === 4) {
        deshabilitarCampos();
      } else if (props.operacion === 2) {
        habilitarCampos();
      }
    }
  }, [props.datos, props.operacion]);

  const deshabilitarCampos = () => {
    const campos = [
      txtCedula, txtNombre, txtFechaNacimiento,
      txtNacionalidad, txtInstitucionEstudio
    ];

    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = true;
    });

    const selects = [cmbParentesco, cmbGradoEstudio];
    selects.forEach(select => {
      if (select.current) select.current.disabled = true;
    });

    const radios = [radioFemenino, radioMasculino, radioEstudiaSi, radioEstudiaNo];
    radios.forEach(radio => {
      if (radio.current) radio.current.disabled = true;
    });
  };

  const habilitarCampos = () => {
    const campos = [
      txtCedula, txtNombre, txtFechaNacimiento,
      txtNacionalidad, txtInstitucionEstudio
    ];

    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = false;
    });

    const selects = [cmbParentesco, cmbGradoEstudio];
    selects.forEach(select => {
      if (select.current) select.current.disabled = false;
    });

    const radios = [radioFemenino, radioMasculino, radioEstudiaSi, radioEstudiaNo];
    radios.forEach(radio => {
      if (radio.current) radio.current.disabled = false;
    });
  };

  const validarCampos = () => {
    const nuevosErrores = {};
    let valido = true;

    // Validar nombre
    if (!txtNombre.current?.value?.trim()) {
      nuevosErrores.nombre = "El nombre del familiar no debe estar en blanco";
      valido = false;
      txtNombre.current?.focus();
    }

    // Validar parentesco
    if (!cmbParentesco.current?.value || cmbParentesco.current.value === "Seleccione...") {
      nuevosErrores.parentesco = "El parentesco del familiar no debe estar en blanco";
      valido = false;
    }

    // Validar fecha de nacimiento
    if (txtFechaNacimiento.current?.value) {
      const fechaNac = moment(txtFechaNacimiento.current.value);
      const fechaActual = moment();

      if (!fechaNac.isValid()) {
        nuevosErrores.fechaNacimiento = "La fecha de nacimiento no es válida";
        valido = false;
      } else if (fechaNac.isAfter(fechaActual)) {
        nuevosErrores.fechaNacimiento = "La fecha de nacimiento no debe ser mayor a la fecha actual";
        valido = false;
      }
    } else {
      nuevosErrores.fechaNacimiento = "La fecha de nacimiento es requerida";
      valido = false;
    }

    setErrores(nuevosErrores);
    return valido;
  };

  const aceptar = () => {
    if (operacion === 1 || operacion === 2) {
      if (!validarCampos()) {
        return;
      }
    }

    // Construir objeto con los datos del formulario
    const datosFamiliar = {
      cedfam: txtCedula.current?.value || '',
      nomfam: txtNombre.current?.value || '',
      fecnac: txtFechaNacimiento.current?.value || '',
      sexo: radioFemenino.current?.checked ? 'FEMENINO' : 'MASCULINO', // Cambiado a texto para el padre
      parent: cmbParentesco.current?.value || '',
      nacfam: txtNacionalidad.current?.value || '',
      estudia: radioEstudiaSi.current?.checked ? true : false, // Cambiado a estudia para el padre
      gradoestudio: cmbGradoEstudio.current?.value || '',
      instituto: txtInstitucionEstudio.current?.value || '',
      // Mantener estos para compatibilidad
      sexfam: radioFemenino.current?.checked ? 1 : 2,
      estfam: radioEstudiaSi.current?.checked ? true : false,
      graest: cmbGradoEstudio.current?.value || '',
      insest: txtInstitucionEstudio.current?.value || ''
    };

    console.log('Datos del familiar a enviar:', datosFamiliar);

    // Devolver los datos al componente padre
    if (props.onAceptar) {
      props.onAceptar(datosFamiliar);
    }

    props.onHide();
  };

  const cancelar = () => {

    // Limpiar campos para nuevo registro
    if (txtCedula.current) txtCedula.current.value = '';
    if (txtNombre.current) txtNombre.current.value = '';
    if (txtFechaNacimiento.current) txtFechaNacimiento.current.value = '';
    if (radioFemenino.current) radioFemenino.current.checked = true;
    if (radioMasculino.current) radioMasculino.current.checked = false;
    if (cmbParentesco.current) cmbParentesco.current.value = '';
    if (txtNacionalidad.current) txtNacionalidad.current.value = '';
    if (radioEstudiaSi.current) radioEstudiaSi.current.checked = false;
    if (radioEstudiaNo.current) radioEstudiaNo.current.checked = true;
    if (cmbGradoEstudio.current) cmbGradoEstudio.current.value = '';
    if (txtInstitucionEstudio.current) txtInstitucionEstudio.current.value = '';
    if (txtCedula.current) txtCedula.current.focus();


    props.onHide();

  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        
        if (props.operacion === 1) {
          // Limpiar campos para nuevo registro
          if (txtCedula.current) txtCedula.current.value = '';
          if (txtNombre.current) txtNombre.current.value = '';
          if (txtFechaNacimiento.current) txtFechaNacimiento.current.value = '';
          if (radioFemenino.current) radioFemenino.current.checked = true;
          if (radioMasculino.current) radioMasculino.current.checked = false;
          if (cmbParentesco.current) cmbParentesco.current.value = '';
          if (txtNacionalidad.current) txtNacionalidad.current.value = '';
          if (radioEstudiaSi.current) radioEstudiaSi.current.checked = false;
          if (radioEstudiaNo.current) radioEstudiaNo.current.checked = true;
          if (cmbGradoEstudio.current) cmbGradoEstudio.current.value = '';
          if (txtInstitucionEstudio.current) txtInstitucionEstudio.current.value = '';
          if (txtCedula.current) txtCedula.current.focus();
        } else if (props.datos) {
          // Para edición o consulta, llenar los campos
          setTimeout(() => {
            llenarCampos(props.datos);
          }, 100);
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 1 && "Incluir Familiar"}
          {operacion === 2 && "Editar Familiar"}
          {operacion === 4 && "Consultar Familiar"}
        </h3>
        <a type="button" onClick={cancelar}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center">
          <legend className="float-none m-0 w-auto">Datos</legend>

          {/* Mostrar errores de validación */}
          {Object.keys(errores).length > 0 && (
            <div className="alert alert-danger col-12" role="alert">
              {Object.values(errores).map((error, index) => (
                <div key={index}>• {error}</div>
              ))}
            </div>
          )}

          <div className="col-md-12 px-0 mx-auto row">
            <div className="input-group input-group-sm mb-1 col-md-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">Cédula: </span>
              <input
                type="text"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                className="form-control"
                ref={txtCedula}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtNombre.current?.focus();
                }}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-9">
              <span className="input-group-text" id="inputGroup-sizing-sm">Nombre: </span>
              <input
                type="text"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                className="form-control"
                ref={txtNombre}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtFechaNacimiento.current?.focus();
                }}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-5">
              <span className="input-group-text" id="inputGroup-sizing-sm">Fecha de Nacimiento: </span>
              <input
                type="date"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                className="form-control"
                ref={txtFechaNacimiento}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') radioFemenino.current?.focus();
                }}
              />
            </div>

            <div className="col-md-3"></div>

            <div className="col-md-4 row m-0 pl-0 d-flex align-items-center">
              <label className="col-md-3 fw-bold">Sexo:</label>
              <div className="form-check col-md-5">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="radioSexo"
                  id="radioFemenino"
                  ref={radioFemenino}
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                />
                <label className="form-check-label my-auto" htmlFor="radioFemenino">
                  Femenino
                </label>
              </div>
              <div className="form-check col-md-4">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="radioSexo"
                  id="radioMasculino"
                  ref={radioMasculino}
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                />
                <label className="form-check-label my-auto" htmlFor="radioMasculino">
                  Masculino
                </label>
              </div>
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <span className="input-group-text" id="inputGroup-sizing-sm">Parentesco: </span>
              <select
                className="form-select"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                ref={cmbParentesco}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtNacionalidad.current?.focus();
                }}
              >
                {opcionesParentesco.map((opcion, index) => (
                  <option key={index} value={index === 0 ? '' : opcion}>
                    {opcion}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <span className="input-group-text" id="inputGroup-sizing-sm">Nacionalidad: </span>
              <input
                type="text"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                className="form-control"
                ref={txtNacionalidad}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') radioEstudiaSi.current?.focus();
                }}
              />
            </div>

            <div className="col-md-4 row m-0 pl-0 d-flex align-items-center">
              <label className="col fw-bold">¿Estudia?:</label>
              <div className="form-check col">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="radioEstudia"
                  id="radioEstudiaSi"
                  ref={radioEstudiaSi}
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                />
                <label className="form-check-label my-auto" htmlFor="radioEstudiaSi">
                  Si
                </label>
              </div>
              <div className="form-check col">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="radioEstudia"
                  id="radioEstudiaNo"
                  ref={radioEstudiaNo}
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                />
                <label className="form-check-label my-auto" htmlFor="radioEstudiaNo">
                  No
                </label>
              </div>
            </div>

            <div className="input-group input-group-sm mb-1 col-md-5">
              <span className="input-group-text" id="inputGroup-sizing-sm">Grado de Estudio: </span>
              <select
                className="form-select"
                ref={cmbGradoEstudio}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtInstitucionEstudio.current?.focus();
                }}
              >
                {opcionesGradoEstudio.map((opcion, index) => (
                  <option key={index} value={index === 0 ? '' : opcion}>
                    {opcion}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group input-group-sm mb-1 col-md-7">
              <span className="input-group-text" id="inputGroup-sizing-sm">Institución de Estudio</span>
              <input
                type="text"
                disabled={operacion === 4 || operacion === 3 ? true : false}
                className="form-control"
                ref={txtInstitucionEstudio}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') aceptar();
                }}
              />
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {(operacion === 1 || operacion === 2) && (
          <button
            type="button"
            className="btn btn-sm rounded-pill col-md-2 btn-success"
            onClick={aceptar}
          >
            Aceptar
          </button>
        )}
        <button
          type="button"
          onClick={cancelar}
          className="btn btn-sm rounded-pill col-md-2 btn-danger"
        >
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};